import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, effect, inject, input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TooltipDirective } from '@sb/tooltip';

import { ButtonComponent } from '../../button';
import { IconComponent } from '../../icon';
import { ChecklistAction, ChecklistItemModel } from '../checklist.model';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'sb-checklist-item',
  templateUrl: './checklist-item.component.html',
  styleUrl: './checklist-item.component.scss',
  imports: [ButtonComponent, IconComponent, NgClass, TooltipDirective],
  host: {
    '[attr.aria-expanded]': 'expanded()',
  },
})
export class ChecklistItemComponent {
  private translate = inject(TranslateService);

  item = input.required<ChecklistItemModel>();
  expanded = input<boolean>();
  listIndex = input<number>();
  hideIsCompletedStatus = input(false);

  trialExtensionLabel = '';
  trialExtensionTooltip = '';

  constructor() {
    effect(() => {
      const item = this.item();
      const extensionInDays = item.trialExtension?.extension_in_days ?? 0;
      if (item.trialExtension) {
        this.trialExtensionLabel =
          extensionInDays === 1
            ? this.translate.instant('+1 day')
            : this.translate.instant('+{{days}} days', { days: extensionInDays });
        this.trialExtensionTooltip = !item.trialExtensionUsed
          ? extensionInDays === 1
            ? this.translate.instant('Extend your trial by 1 day when you complete this step!') + ' 🎉'
            : this.translate.instant('Extend your trial by {{days}} days when you complete this step!', {
                days: extensionInDays,
              }) + ' 🎉'
          : '';
      }
    });
  }

  onClick(action?: ChecklistAction) {
    if (!action) {
      return;
    }

    action();
  }
}
